<template>
  <ValidationObserver ref="form" v-slot="{ handleSubmit }">
    <form class="mt-4" novalidate @submit.prevent="handleSubmit(onSubmit)">
      <ValidationProvider vid="username" name="username" rules="required" v-slot="{ errors }">
        <div class="form-group">
          <input
            type="text"
            :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"
            id="usernameInput"
            aria-describedby="usernameHelp"
            v-model="user.username"
            placeholder="Tên đăng nhập"
            required
          />
          <div class="invalid-feedback">
            <span>{{ errors[0] }}</span>
          </div>
        </div>
      </ValidationProvider>
      <ValidationProvider vid="password" name="password" rules="required" v-slot="{ errors }">
        <div class="form-group">
          <input
            type="password"
            :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"
            id="passwordInput"
            v-model="user.password"
            placeholder="Mật khẩu"
            required
          />
          <div class="invalid-feedback">
            <span>{{ errors[0] }}</span>
          </div>
        </div>
      </ValidationProvider>
      <div class="d-inline-block w-100">
        <button type="submit" class="btn btn-primary float-right">Đăng nhập</button>
      </div>
      <div class="sign-info">
      </div>
      <div>
        <b-alert :show="serverErrors !== ''" variant="danger" class="bg-red">
          <div class="iq-alert-text">{{serverErrors}}</div>
        </b-alert>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>

import { localize } from 'vee-validate'
import { findash } from '../../../../config/pluginInit'

export default {
  name: 'SignIn1Form',
  props: ['formType', 'username', 'password'],
  data: () => ({
    user: {
      username: '',
      password: ''
    },
    serverErrors: ''
  }),
  created () {
    localize('en', {
      fields: {
        'password': { required: 'Mật khẩu không được để trống' },
        'username': { required: 'Tên đăng nhập không được để trống' }
      }
    })
  },
  mounted () {
    this.user.username = this.$props.username
    this.user.password = this.$props.password
  },
  computed: {
  },
  methods: {
    onSubmit () {
      this.$store.dispatch('Auth/authUserAction', this.user).then((result) => {
        findash.loadApplicationData()

        this.$router.push({ name: 'dashboard.home-1' })
      }).catch((errors) => {
        this.serverErrors = errors
      })
    }
  }
}
</script>
